import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import { useProjectId } from "hooks/useProjectId";
import ForumPostService from "services/projects/ForumPostService";
import PostCard from "../../Forum/PostCard";
import classes from "./classes.module.scss";

const forumPostService = container.resolve(ForumPostService);

export default function CastingForum() {
	const { posts } = useCastingPosts();

	return (
		<div className={classes["root"]}>
			<div className={classes["posts-container"]}>
				{posts.map((post) => (
					<PostCard key={post.id} post={post} />
				))}
			</div>
		</div>
	);
}

const useCastingPosts = () => {
	const { projectId } = useProjectId();
	const [posts, setPosts] = useState<ForumPostResponseResource[]>([]);

	const fetchPosts = useCallback(() => {
		return forumPostService
			.getCastingPosts(projectId)
			.then(setPosts)
			.catch((error) => {
				console.error(error);
				setPosts([]);
			});
	}, [projectId]);

	useEffect(() => {
		fetchPosts();
	}, [fetchPosts]);

	return { posts };
};
